import React from "react"

import arrowImage from "../../../resources/images/arrow.i.svg"

import { LocaleContext, Direction } from "../../i18n/LocaleContext"
import { FlexLayout } from "../flex/FlexLayout"
import { TestProps } from "../../helpers/TestProps"

const MoveLayoutSource: React.FunctionComponent = () => null
const MoveLayoutTarget: React.FunctionComponent = () => null

export interface MoveLayoutProps extends TestProps {
  /**
   * Whether the move source and target should be laid out as a row or column. Default is row.
   */
  direction?: "row" | "column"
}

/**
 * Layout that directs to move item (displays overlay blue arrow).
 */
export class MoveLayout extends React.PureComponent<MoveLayoutProps> {
  public static Source = MoveLayoutSource
  public static Target = MoveLayoutTarget

  public getArrowImageClassName(direction: Direction) {
    let iconDirection = "right"

    switch (this.props.direction) {
      case "column":
        iconDirection = "down"
        break
      case "row":
        iconDirection = direction === "ltr" ? "right" : "left"
        break
    }

    return `move-layout__icon move-layout__icon--${iconDirection}`
  }

  public getSourceAndTarget() {
    let sourceItem: React.ReactNode | null = null
    let targetItem: React.ReactNode | null = null

    React.Children.forEach(this.props.children, (child) => {
      if (React.isValidElement(child)) {
        if (child.type === MoveLayout.Source) {
          sourceItem = child.props.children
        } else if (child.type === MoveLayout.Target) {
          targetItem = child.props.children
        }
      }
    })

    return { source: sourceItem, target: targetItem }
  }

  public render() {
    const { testID } = this.props
    const { source, target } = this.getSourceAndTarget()
    const layoutDirection = this.props.direction ?? "row"

    return (
      <LocaleContext.Consumer>
        {({ direction }) => (
          <div className="move-layout">
            <img className={this.getArrowImageClassName(direction)} src={arrowImage} alt=""/>
            <FlexLayout direction={layoutDirection}>
              <FlexLayout.Item size="1fr" testID={testID ? `${testID}-source` : undefined}>
                {source}
              </FlexLayout.Item>
              <FlexLayout.Splitter />
              <FlexLayout.Item size="1fr" testID={testID ? `${testID}-target` : undefined}>
                {target}
              </FlexLayout.Item>
            </FlexLayout>
          </div>
        )}
      </LocaleContext.Consumer>
    )
  }
}
